module.exports = __webpack_public_path__ + "img/logo_badge_googlePlay.ccbf6bba.png";